import script from "./ActivityDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityDetails.vue?vue&type=script&setup=true&lang=js"

import "./ActivityDetails.vue?vue&type=style&index=0&id=1374785a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1374785a"]])

export default __exports__